import React, { useCallback, useEffect, useState } from 'react';
import styles from './Training.module.css';
import { CustomButton, CustomFooter, CustomImage, CustomLink, CustomLoader, CustomMoreSection, CustomText, CustomTitle } from '../../../components';
import { useTranslation } from 'react-i18next';
import image from '../../../assets/img/project_image.jpg';
import { getTrainingById } from '../../../services/trainingService';
import { useParams } from 'react-router-dom';
import { ReactComponent as ShareIcon } from '../../../assets/icons/icon_share_dark.svg';

const Training = () => {

    const { trainingId } = useParams();
    const {t} = useTranslation();

    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [training, setTraining] = useState<any>(null);

    const handleGetTraining = useCallback(async () => {
        try {
            if (trainingId) {
                setIsLoading(true);

                const training = await getTrainingById(trainingId);

                setTraining(training);
                setIsLoading(false);
            }
        } catch (error) {
            console.error(error);
            throw error;
        }
    }, [trainingId]);

    useEffect(() => {
        handleGetTraining();
    }, [handleGetTraining]);

    const handleShare = async (url: string, title: string, description: string) => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: title,
                    text: description,
                    url: url,
                });
            } catch (error) {
                console.error('Erreur lors du partage :', error);
            }
        } else {
            alert("Le partage n'est pas supporté par ce navigateur.");
        }
    }

    const getTrainingUrl = (id: string) => {
        return `${process.env.REACT_APP_API_BASE_URL}/training/${id}`;
    }

    return (
        <div>
            { !isLoading && training &&
                <>
                    <div className={styles.content}>
                        <div className={styles.containerTraining}>
        
                            <div>
                                <CustomText><b><CustomLink className={styles.triningLink} to='/training'>{t('navbar.training')}</CustomLink></b> | <b>{training.title}</b></CustomText>

                                <CustomImage
                                    alt=''
                                    src={`${process.env.REACT_APP_API_BASE_URL}${training.image?.url}` || image}
                                    className={styles.trainingImage}
                                />
                            </div>

                            <div className={styles.trainingDetails}>
                                <div className={styles.titleContainer}>
                                    <CustomTitle className={styles.trainingTitle}>{training.title}</CustomTitle>
                                </div>

                                <CustomText className={styles.description}>{training.content}</CustomText>

                                <div className={styles.buttonsContainer}>
                                    <CustomButton sx={{padding: '0.8rem'}} color={"info"} onClick={() => handleShare(getTrainingUrl(training.documentId!) ,training.title, training.content)}>{t('general.share')}<ShareIcon style={{marginLeft: '0.5rem'}} /></CustomButton>
                                </div>
                            </div>
                        </div>
                    </div>

                    <CustomMoreSection />
                    <CustomFooter />
                </>
            }

            {isLoading &&
                <div className={styles.container_loader}>
                    <CustomLoader isLoading={isLoading} loaderType='skeleton' />
                </div>
            }
        </div>
    );
}

export default Training;